import React from 'react'
import ReactMarkdown from 'react-markdown'

import { Link, Typography } from '@mui/material'

const componentMapping = {
  ...Object.fromEntries(
    Array.from({ length: 6 }, (_, i) => [
      `h${i + 1}`,
      { Component: Typography, defaultProps: { variant: `h${i + 1}` } },
    ]),
  ),
  p: { Component: Typography },
  li: { Component: Typography, defaultProps: { component: 'li' } },
  a: { Component: Link },
}

const MarkdownContent = ({ content, overrideProps = {} }) => (
  <ReactMarkdown
    children={content}
    components={Object.fromEntries(
      Object.entries(componentMapping).map(
        ([tag, { Component, defaultProps = {} }]) => [
          tag,
          (props) => (
            <Component
              {...{ ...defaultProps, ...overrideProps[tag], ...props }}
            />
          ),
        ],
      ),
    )}
  />
)

export default MarkdownContent
